import { render, staticRenderFns } from "./GoodBrand.vue?vue&type=template&id=36f74d47&"
import script from "./GoodBrand.vue?vue&type=script&lang=js&"
export * from "./GoodBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports